import React from "react";
import { motion } from "framer-motion";

const techStack = {
    Languages: ["JavaScript", "TypeScript", "Python", "C#", "Java", "Go"],
    "Backend Frameworks": [
        "Node.js",
        "Express.js",
        "NestJS",
        "Flask",
        "FastAPI",
        "Spring Boot",
        ".NET Core"
    ],
    ORM: ["Sequelize", "Mongoose", "TypeORM", "Prisma", "Entity Framework"],
    Databases: [
        "MySQL",
        "PostgreSQL",
        "MSSQL",
        "MongoDB",
        "Oracle DB",
        "Redis",
        "Elasticsearch",
        "SQLite"
    ],
    DevOps: ["Docker", "Kubernetes", "GitHub Actions", "Jenkins", "Terraform", "Helm"],
    Cloud: ["AWS", "GCP", "Azure", "Firebase", "DigitalOcean", "Vercel"],
    API: ["Swagger", "Postman", "GraphQL", "gRPC", "REST"],
    Messaging: ["Redis", "RabbitMQ", "Kafka", "Amazon SQS"],
    Security: ["OAuth2", "JWT", "Keycloak", "Okta", "Firebase Auth"],
    Monitoring: ["Prometheus", "Grafana", "ELK Stack", "Datadog", "Sentry"],
    // ERP_SaaS: ["Odoo", "SAP BTP", "Apache Camel", "Camunda BPM", "Metabase"]
};

export default function TechStackGrid() {
    return (
        <motion.div
            className="p-1 py-5"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
        >
            <h1 className="text-3xl font-bold text-center">We Build with the Best</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {Object.entries(techStack).map(([category, tools], index) => (
                    <motion.div
                        key={category}
                        className="bg-white p-4 rounded-2xl shadow-md"
                        initial={{ y: 40, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: index * 0.1, duration: 0.5 }}
                    >
                        <h2 className="text-xl font-semibold mb-4 text-indigo-600">{category}</h2>
                        <p className="text-gray-700">
                            {tools.join(", ")}
                        </p>
                    </motion.div>
                ))}
            </div>
        </motion.div>
    );
}
